__turbopack_context__.v({
  "card": "ParagraphFeatures4Col-module__eVGmgq__card",
  "desc": "ParagraphFeatures4Col-module__eVGmgq__desc",
  "grid": "ParagraphFeatures4Col-module__eVGmgq__grid",
  "header": "ParagraphFeatures4Col-module__eVGmgq__header",
  "iconBox": "ParagraphFeatures4Col-module__eVGmgq__iconBox",
  "lead": "ParagraphFeatures4Col-module__eVGmgq__lead",
  "name": "ParagraphFeatures4Col-module__eVGmgq__name",
  "title": "ParagraphFeatures4Col-module__eVGmgq__title",
});
